export type FaqSource = (typeof sources)[number]['key']

export const sources = [
	{ title: 'Parents and Students', key: 'parents-and-students' },
	{ title: 'Teachers', key: 'teachers' },
] as const
export const defaultSource: FaqSource = 'parents-and-students' as const
export const faqUrl = (source: FaqSource) => `/faq/${source}`

export type FaqQuestion = null
